'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeToReducer;

var _typeToReducer2 = require('type-to-reducer');

var _typeToReducer3 = _interopRequireDefault(_typeToReducer2);

var _config = require('config');

var _types = require('shared/modules/Home/types');

var _types2 = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  total: 0,
  page: 0
};

var BREAKPOINTS = [{
  width: 600,
  number: 1
}, {
  width: 900,
  number: 2
}, {
  width: 1050,
  number: 3
}];

var getNumberPerPage = function getNumberPerPage() {
  if (_config.CLIENT) {
    for (var i = 0; i < BREAKPOINTS.length; i++) {
      if (window.innerWidth <= BREAKPOINTS[i].width) {
        return BREAKPOINTS[i].number;
      }
    }
  }

  return 4;
};

var getPage = function getPage(dir, _ref) {
  var page = _ref.page,
      total = _ref.total;

  if (dir === 0 && page === 0) {
    return total - getNumberPerPage();
  } else if (dir === 1 && page + getNumberPerPage() >= total) {
    return 0;
  } else if (dir === 0) {
    return page - 1;
  }

  return page + 1;
};

exports.default = (0, _typeToReducer3.default)((_typeToReducer = {}, (0, _defineProperty3.default)(_typeToReducer, _types2.SLIDE_CAROUSEL, function (state, _ref2) {
  var dir = _ref2.dir;

  return (0, _extends3.default)({}, state, {
    page: getPage(dir, state)
  });
}), (0, _defineProperty3.default)(_typeToReducer, _types.GET_HOME, {
  FULFILLED: function FULFILLED(state, _ref3) {
    var response = _ref3.response;
    var highlightedJobs = response.highlightedJobs;


    return (0, _extends3.default)({}, state, {
      total: highlightedJobs.length
    });
  }
}), _typeToReducer), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/HighlightedJobs/reducer.js
// module id = 1076
// module chunks = 0